import React from 'react'
import type { ServiceGroup } from 'src/store/data.store'
import { formatPrice } from 'utils/formatPrice'
import { Modal } from 'components/Utility/Modal/Modal'
import styles from './ServiceOptionsModal.module.scss'

type ServiceOptionsModalProps = {
  group: ServiceGroup,
  isOpen: boolean,
  onClose: () => void,
  /** Called with the picked option's service */
  onSelect: (serviceId: number) => void,
}

/** Asks which option of a service page to book */
export const ServiceOptionsModal: React.FC<ServiceOptionsModalProps> = (props) => {
  const { group, isOpen, onClose, onSelect } = props
  return (
    <Modal isOpen={isOpen} center className={styles.container} title={group.page.title} onClose={onClose}>
      <div className={styles.subtitle}>Выберите вариант</div>
      <div className={styles.options}>
        {group.options.map((option) => (
          <button
            key={option.service.id}
            type={'button'}
            className={styles.option}
            onClick={() => onSelect(option.service.id)}
          >
            <span className={styles.optionTitle}>{option.title}</span>
            <span className={styles.optionDuration}>{option.service.duration} мин</span>
            <span className={styles.optionPrice}>{formatPrice(option.service)}&nbsp;₽</span>
          </button>
        ))}
      </div>
    </Modal>
  )
}
